import { Badge } from '@klear/ui/components/badge'
import { cn } from '@klear/ui/lib/utils'
import type { NextStep } from '@klear/schema/document-review-step'
import { NEXT_STEP_LABELS } from '@/app/document-review/next-steps'

const NEXT_STEP_BADGE_CLASSES: Record<NextStep, string> = {
  blocked: 'bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300',
  waitingOnYou: 'bg-amber-100 text-amber-900 dark:bg-amber-950 dark:text-amber-200',
  waitingOnParent: 'bg-amber-100 text-amber-900 dark:bg-amber-950 dark:text-amber-200',
  readyToApprove: 'bg-green-100 text-green-800 dark:bg-green-950 dark:text-green-300',
  processing: 'bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-300',
  creatingRecords: 'bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-300',
  notProcessed: 'bg-secondary text-secondary-foreground',
  filed: 'bg-green-100 text-green-800 dark:bg-green-950 dark:text-green-300',
  filedAutomatically: 'bg-green-100 text-green-800 dark:bg-green-950 dark:text-green-300',
  filedByLaterRun: 'bg-secondary text-secondary-foreground',
  superseded: 'bg-secondary text-secondary-foreground',
  dismissed: 'bg-secondary text-secondary-foreground'
}

export function NextStepBadge({ step, className }: { step: NextStep; className?: string }) {
  return <Badge className={cn(NEXT_STEP_BADGE_CLASSES[step], className)}>{NEXT_STEP_LABELS[step]}</Badge>
}
